export const ALL_LICENSES_ASSIGNED_TEXT = 'All Licenses assigned'
export const LICENSES_ASSIGNED_TEXT = 'Licenses assigned'
export const NO_LICENSES_ASSIGNED_TEXT = 'You have no Licenses to assign'
